import TextAlignWidget from './TextAlignWidget';

export default TextAlignWidget;
